import { limit } from './limit';

export * from './lottie';
export * from './array';
export * from './number';
export * from './string';
export * from './markdown';
export * from './numberOfListings';
export * from './limit';
export * from './window';

export function calculateProgress(
  initial,
  target,
  progress,
  unit = '',
) {
  const newProgress = initial - progress * (initial - target);
  return unit ? newProgress + unit : newProgress;
}

export const configGenerator = (config, property, from, to) => (
  {
    from: { [property]: from },
    ...to ? { to: { [property]: to } } : {},
    ...config,
  }
);

export const calculateValueWithSpeed = (value, threshold, speed) => (
  limit(((value - threshold) * speed))
);

export function void0() {
  return undefined;
}
